/**
 * CW31 (customer 31.10.2026): a catalogue may name a flag (`archive_field`, contracts: «Действует») whose «нет» lists a
 * row apart, under «Архив»: the rows in force come first, the others are still there to choose. Without the flag, or
 * when nothing is archived, the list stays one plain list as before.
 */
export type RefOption = { value: string; label: string; weight: number };
export type RefOptionGroup = { label: string; title: string; options: RefOption[] };

export function withArchive(
  options: RefOption[],
  rows: Record<string, unknown>[],
  field: string | null | undefined,
  valueField = "id",
): Array<RefOption | RefOptionGroup> {
  if (!field) return options;
  const archived = new Set(rows.filter((r) => r[field] === false).map((r) => String(r[valueField])));
  if (!archived.size) return options;
  const current = options.filter((o) => !archived.has(o.value));
  const old = options.filter((o) => archived.has(o.value));
  return [
    ...(current.length ? [{ label: "Действующие", title: "Действующие", options: current }] : []),
    { label: "Архив", title: "Архив", options: old },
  ];
}
